import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MsalModule, MsalGuard, MsalInterceptor } from "@azure/msal-angular";
import { environment } from "@environments/environment";
import { AuthenticationService } from "./authentication.service";
import { TokenInterceptor } from "./token.interceptor";

const baseUrl = environment.api.base;
const baseUploadUrl = environment.api.baseUpload;
const scope = environment.api.scope;

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  imports: [
    MsalModule.forRoot(
      {
        auth: {
          clientId: environment.auth.clientId,
          authority: environment.auth.authority,
          validateAuthority: true,
          redirectUri: environment.auth.redirectUri,
          postLogoutRedirectUri: environment.auth.postLogoutRedirectUri,
          navigateToLoginRequestUrl: true,
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: isIE, // set to true for IE 11
        },
      },
      {
        popUp: !isIE,
        consentScopes: ["user.read", "openid", "profile"],
        unprotectedResources: [
          /* 'https://www.microsoft.com/en-us/' */
        ],
        protectedResourceMap: [
          [
            `${baseUrl}utils/ocr`,
            [`${scope}`],
          ],
          [
            `${baseUrl}utils/requirements`,
            [`${scope}`],
          ],
          [
            `${baseUrl}utils/criteria`,
            [`${scope}`],
          ],
          [
            `${baseUrl}utils/data`,
            [`${scope}`],
          ],
          [
            `${baseUrl}users/authorization`,
            [`${scope}`],
          ],
          [
            `${baseUrl}users/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}users/user/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}users/user/*/check`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/date`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/*/findings`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/*/opinions`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/date`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/dates`,
            [`${scope}`],
          ],
          [
            `${baseUrl}trainings/models`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests/parameters/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests/suggested`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests/details`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests/dictionary/*/test`,
            [`${scope}`],
          ],
          [
            `${baseUrl}tests/dictionary/*/icr`,
            [`${scope}`],
          ],
          [
            `${baseUrl}summary-reports/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}summary-reports/*/draft`,
            [`${scope}`],
          ],
          [
            `${baseUrl}scores/ranges`,
            [`${scope}`],
          ],
          [
            `${baseUrl}scores/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/observations`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/*/observations`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/observations/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/observations/list`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/*/informations`,
            [`${scope}`],
          ],
          [
            `${baseUrl}icrs/*/complete`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas/*`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas/*/save-time`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas/*/complete`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas/*/information`,
            [`${scope}`],
          ],
          [
            `${baseUrl}efas/history`,
            [`${scope}`],
          ],
          [
            `${baseUrl}convergences/lms`,
            [`${scope}`],
          ],
          [
            `${baseUrl}convergences/ezshare`,
            [`${scope}`],
          ],
          [
            `${baseUrl}convergences/users`,
            [`${scope}`],
          ],
          [
            `${baseUrl}dictionarys/keywords`,
            [`${scope}`],
          ],
          [
            `${baseUrl}dictionarys/keywords/*`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}*`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}documents**`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}documents/**`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}documents*`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}documents/*`,
            [`${scope}`],
          ],
          [
            `${baseUploadUrl}documents[*]`,
            [`${scope}`],
          ],
        ],
        extraQueryParameters: {},
      }
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    MsalGuard,
    AuthenticationService,
  ],
  exports: [MsalModule],
})
export class AuthenticationModule {}
